export interface AppEnvironment {
  production: boolean;
  name: string;
  hosts: {
    [name: string]: AppHostConfig
  };
  values: {
    cache: {
      enabled: boolean;
      'max-age': number;
    };
    dwspayPublishKey?: string; // DWSPay publishable key (WS-Payments platform account)
    [key: string]: any; // Per mantenere la flessibilità di aggiungere altri valori
  };
}

export interface AppHostConfig {
  host?: string;
  protocol?: string;
  port?: string;
  root?: string;
  endpoints?: any;
}


export const environment: AppEnvironment = {
  production: false,
  name: 'common',
  values: {
    cache: {
      enabled: false,
      'max-age': 10 * 60 * 1000
    },
    dwspayPublishKey: 'pk_test_51SXP0hLEjrO5JiWJchGFqzqV2IyosENiEgF3CHeboxjiPtxAGVFIXpYNndsmkOeT90oNexGTgdNu0jWqUEsL1V5O00bgPx2mQi',
    googlePlacesApiKey: 'AIzaSyDITjW8j9D705OAUqyTnuRK8OrRoHWiBvw'
  },
  hosts: {
    wsb2c: {
      host: 'localhost',
      protocol: 'http',
      port: '5525',
      root: '/api/public/',
      endpoints:{}
    }
  }
};
